import React from 'react';
import { Card, Button, Tag, Modal } from 'antd';
import { cardBrandLabel } from '../../helpers/stripe';
const CardDisplay = ({ 
  card, 
  onDelete, 
  onSetDefault, 
  isDefault = false,
  showActions = true,
  totalCards = 1
}) => {

  const getCardIcon = (cardType) => {
    switch (cardType && cardType.toLowerCase()) {
      case 'visa':
        return '💳';
      case 'mastercard':
        return '💳';
      case 'american express':
        return '💳';
      case 'discover':
        return '💳';
      default:
        return '💳';
    }
  };

  const getCardColor = (cardType) => {
    switch (cardType && cardType.toLowerCase()) {
      case 'visa':
        return '#1A1F71';
      case 'mastercard':
        return '#EB001B';
      case 'american express':
        return '#006FCF';
      case 'discover':
        return '#FF6000';
      default:
        return '#1890ff';
    }
  };

  const formatCardNumber = (lastFour) => {
    return `•••• •••• •••• ${lastFour}`;
  };

  const formatExpiryDate = (expDate) => {
    if (!expDate || expDate.length !== 4) return expDate;
    return `${expDate.substring(0, 2)}/${expDate.substring(2, 4)}`;
  };

  const handleDelete = () => {
    // Prevent deletion if this is the only card
    if (totalCards <= 1) {
      Modal.warning({
        title: 'Cannot Delete Card',
        content: 'You cannot delete the last remaining card. Please add another card first.',
        okText: 'OK',
      });
      return;
    }

    Modal.confirm({
      title: 'Delete Card',
      content: 'Are you sure you want to delete this card? This action cannot be undone.',
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: () => onDelete(card.id),
    });
  };

  return (
    <Card
      style={{
        background: `linear-gradient(135deg, ${getCardColor(cardBrandLabel(card.cardType))} 0%, ${getCardColor(cardBrandLabel(card.cardType))}CC 100%)`,
        color: 'white',
        border: isDefault ? '2px solid #52c41a' : '1px solid #d9d9d9',
        borderRadius: '12px',
        position: 'relative',
        overflow: 'hidden',
      }}
      bodyStyle={{ padding: '20px' }}
    >
      {/* Card Header */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'flex-start',
        marginBottom: '20px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '24px' }}>
            {getCardIcon(card.cardType)}
          </span>
          <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
            {cardBrandLabel(card.cardType)}
          </span>
        </div>
        
        {isDefault && (
          <Tag color="green" style={{ margin: 0 }}>
            Default
          </Tag>
        )}
      </div>

      {/* Card Number */}
      <div style={{ 
        fontSize: '18px', 
        fontWeight: 'bold', 
        letterSpacing: '2px',
        marginBottom: '15px',
        fontFamily: 'monospace'
      }}>
        {formatCardNumber(card.lastFour)}
      </div>

      {/* Card Details */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '15px'
      }}>
        <div>
          <div style={{ fontSize: '12px', opacity: 0.8, marginBottom: '2px' }}>
            CARDHOLDER
          </div>
          <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
            {card.cardholderName}
          </div>
        </div>
        <div>
          <div style={{ fontSize: '12px', opacity: 0.8, marginBottom: '2px' }}>
            EXPIRES
          </div>
          <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
            {formatExpiryDate(card.expDate)}
          </div>
        </div>
      </div>

  {/* (Details removed as per requirement) */}

      {/* Actions */}
      {showActions && (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          alignItems: 'center',
          gap: '10px',
          borderTop: '1px solid rgba(255,255,255,0.2)',
          paddingTop: '15px'
        }}>
          {!isDefault && (
            <Button
              type="primary"
              onClick={() => onSetDefault(card.id)}
              size="small"
              style={{ 
                background: 'rgba(255,255,255,0.2)', 
                border: '1px solid rgba(255,255,255,0.3)',
                color: 'white'
              }}
            >
              Set Default
            </Button>
          )}
          <Button
            type="default"
            className="deleteButton"
            icon="delete"
            size="small"
            onClick={handleDelete}
            disabled={totalCards <= 1}
            style={{ 
              background: totalCards <= 1 ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.2)', 
              border: '1px solid rgba(255,255,255,0.3)',
              color: totalCards <= 1 ? 'rgba(255,255,255,0.5)' : 'white',
              cursor: totalCards <= 1 ? 'not-allowed' : 'pointer',
              borderRadius: '4px'
            }}
            title={totalCards <= 1 ? 'Cannot delete the last remaining card' : 'Delete card'}
          >
            
          </Button>
        </div>
      )}

      {/* Decorative Elements */}
      <div style={{
        position: 'absolute',
        top: '-20px',
        right: '-20px',
        width: '80px',
        height: '80px',
        background: 'rgba(255,255,255,0.1)',
        borderRadius: '50%',
        zIndex: 0
      }} />
      <div style={{
        position: 'absolute',
        bottom: '-30px',
        left: '-30px',
        width: '60px',
        height: '60px',
        background: 'rgba(255,255,255,0.1)',
        borderRadius: '50%',
        zIndex: 0
      }} />
    </Card>
  );
};

export default CardDisplay;
